'use strict';

var AppState = require('app_state');
var Consts = require('consts');
var I18N = require('utils/i18n');
var Misc = require('utils/misc');

var getAlarmTimeParts = function (v) {
    v = parseInt(v);
    if (v >= 1440 && v % 1440 == 0) return { value: v / 1440, unit: 1440 };
    if (v >= 60) return { value: v / 60, unit: 60 };

    return { value: v, unit: 1 };
};

var Alarm = {
    getPriorityText: function (prio) {
        return Misc.selectWhereFirst(
            Consts.Priorities(),
            function (a) {
                return a.prio == prio;
            },
            'name'
        );
    },

    getConditionText: function (row, extMode, alarm) {
        if (!row || !row.line1) return '--';

        var comparison = row.comparison;
        var flip = { '<': '>', '>': '<', '<=': '>=', '>=': '<=' };

        if (row.actual !== undefined) {
            if (flip[row.comparison] && !eval('' + row.actual + row.comparison + row.threshold)) {
                comparison = flip[row.comparison];
            }
        }

        var getOccLineName = function (row, idx, categories) {
            return I18N.DATAPOINT(categories, row['line' + idx + '_name']);
        };

        var getValueText = function (row, value, categories) {
            if (row.op == 'Z') {
                return value + ' %';
            }

            if (row.line1_name) {
                var type = row.line1 || '';
                var parts = row.line1.split('_');
                if (parts.length > 0) {
                    type = parts[0];
                }

                var dinfo = Misc.getValueDisplayInfos(value, type, row.value_format, row.data_unit);
                return dinfo.value + ' ' + dinfo.unit;
            }

            return Alarm.getValueTextByKey(row.line1key || row.line1 || '', value, categories);
        };

        var getLineName = function (line, categories) {
            var lineParts = line.split('$');
            var id = lineParts[0];

            if (id == Consts.AlarmStatusField) {
                return Consts.AlarmStatusFieldText;
            }
            var lineData = AppState.availableColumnDataByKey(line, categories);

            if (lineData) {
                return I18N.DATAPOINT((lineData.categories || [''])[0], lineData.name);
            }

            return id;
        };

        var categories = alarm && alarm.filter && alarm.filter.category;

        var l = getOccLineName(row, 1, categories) || getLineName(row.line1key || row.line1, categories);
        if (row.op && row.line2) {
            l = Misc.getOperatorText(
                l,
                row.op,
                getOccLineName(row, 2, categories) || getLineName(row.line2key || row.line2, categories)
            );
        }

        var compOp =
            Misc.selectWhereFirst(Consts.Backend.Comparison, function (item) {
                return item.k == comparison;
            }) || {};
        var result =
            (row.actual !== undefined ? compOp.formatOccurence : undefined) || I18N.TR(compOp.format) || '$1 @op $2';

        if (row.actual !== undefined && row.line1 != Consts.AlarmStatusField) {
            l = l + ' (' + getValueText(row, row.actual, alarm && alarm.filter && alarm.filter.category) + ')';
        }

        if (l.indexOf('@comparison') != -1) {
            // insert comparision operator
            result = l.replace('@comparison', '@op $2');
        }

        result = result
            .replace('$1', l)
            .replace(
                '$2',
                getValueText(row, row.value || row.threshold || 0, alarm && alarm.filter && alarm.filter.category)
            )
            .replace('@op', I18N.TR(compOp.o));
        result = result.replace(/^[ ]+|[ ]+$/g, '');

        if (extMode) {
            result = { text: result, items: [] };

            if (row.line1 == Consts.AlarmStatusField) {
                var category =
                    (alarm && alarm.device_category) ||
                    (alarm && alarm.filter && alarm.filter.category && alarm.filter.category.length == 1
                        ? alarm.filter.category[0]
                        : 'Gateway');
                var bits = Alarm.decodeStatus(row.value || row.threshold);
                var errors = (Consts.DeviceCategory[category] || {}).statusErrors;

                _.each(bits, function (bit) {
                    _.each((errors || {}).codes, function (code, key) {
                        if (bit == code) {
                            if (
                                row.comparison == 'NONEOF' ||
                                row.actual === undefined ||
                                row.actual == code ||
                                ((row.actual & code) == code && parseInt(code) > 0 && parseInt(row.actual) > 0)
                            ) {
                                var bitMsg = errors.messages[key];
                                if (alarm.device_status_data && alarm.device_status_data[code]) {
                                    var items = _.map(alarm.device_status_data[code], function (nr) {
                                        return alarm.report_values['MBR_' + nr].name;
                                    });

                                    items = Misc.selectWhere(items, function (x) {
                                        return x;
                                    }).join(', ');
                                    if (items) {
                                        bitMsg += ' (' + items + ')';
                                    }
                                }
                                result.items.push(bitMsg);
                            }
                        }
                    });
                });
            }
        }

        return result;
    },

    getAlarmTime: function (v, nullText) {
        var parts = getAlarmTimeParts(v);
        if (parts.value == 0) return '<strong>' + nullText + '</strong>';

        var unitStr = '';
        switch (parts.unit) {
            case 1440:
                unitStr = I18N.TR('Tagen');
                break;
            case 60:
                unitStr = I18N.TR('Stunden');
                break;
            case 1:
                unitStr = I18N.TR('Minuten');
                break;
        }

        return I18N.TR('nach') + ' <strong>' + parts.value + ' ' + unitStr + '</strong>';
    },

    getStatusValues: function (categories) {
        var statusValues = Misc.getStatusValues(categories);
        return _.sortBy(
            Misc.selectWhere(statusValues, function (st) {
                return st.value == -1 || st.value == -2 || st.value > 0;
            }),
            function (st) {
                return st.value;
            }
        );
    },

    encodeStatus: function (status) {
        var result = 0;
        _.each(status, function (value) {
            var bit = parseInt(value);
            if (bit > 0) {
                result += bit;
                return;
            }

            var x = Math.pow(2, bit - 1);
            result += x;
        });
        return result;
    },

    decodeStatus: function (code) {
        // status bits
        if (code <= 0) return [code];

        var statusBits = Math.floor(code);
        var bit = 1;
        var result = [];

        var counter = 1024;
        while (statusBits > 0 && counter > 0) {
            if (statusBits % 2) {
                result.push(bit);
            }
            statusBits = Math.floor(statusBits / 2);
            bit = bit * 2;
            counter--;
        }

        // special (negative) status values
        var negPart = code - Math.floor(code);
        var bit = 0.5;
        var cnt = 0;

        while (negPart > 0) {
            if (negPart >= bit) {
                result.push('' + cnt);
                negPart = negPart - bit;
            }
            bit = bit / 2;
            cnt--;
        }

        return result;
    },

    updateConditionsKey: function (rows, categories) {
        var prepareKey = function (key, line) {
            var field = AppState.availableColumnDataByKey(key || line || '', categories);
            if (line == Consts.AlarmStatusField) {
                field = { id: Consts.AlarmStatusField, name: Consts.AlarmStatusFieldText, unit: '' };
            }

            if (field) {
                return Alarm.getDeviceValueKey(field);
            }

            return key || line;
        };

        rows.forEach(function (row) {
            row.line1key = prepareKey(row.line1key || '', row.line1);
            if (row.line2 && row.op) {
                row.line2key = prepareKey(row.line2key || '', row.line2);
            }
        });
    },

    getDeviceValueKey: function (info) {
        return info.id + '$' + (info.unit || '') + '$' + info.name;
    },

    getValueTextByKey: function (key, value, categories) {
        var valueData = AppState.availableColumnDataByKey(key, categories) || {};
        var valueUnit = Misc.getValueDisplayInfos(
            value,
            valueData.id || '',
            valueData.format || '',
            valueData.unit || '',
            valueData.display_unit || '',
            valueData.is_unit_fixed || false
        );

        return '' + valueUnit.value + ' ' + valueUnit.unit;
    },

    getIDFromKey: function (key) {
        if (!key) {
            return undefined;
        }

        var parts = key && key.split('$');
        return parts.length > 0 ? parts[0] : '';
    },
};

module.exports = Alarm;
